import { type LucideIcon } from 'lucide-react';

interface IconLabelProps {
  icon: LucideIcon;
  value: string;
}

export function IconLabel({ icon: Icon, value }: IconLabelProps) {
  return (
    <span className="flex items-center gap-1.5">
      <Icon className="h-3.5 w-3.5" />
      {value}
    </span>
  );
}
